import { lazy } from 'react';

const NewInvoice = lazy(() => import('./NewInvoice'));

export default NewInvoice;
